import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useState } from 'react';

export default function MetricsCard({
  data,
  loading,
  setHovered,
  hovered,
  id,
}) {
  return (
    <div
      onMouseEnter={() => (setHovered ? setHovered(id) : null)}
      onMouseLeave={() => (setHovered ? setHovered(null) : null)}
      className={`transition-all duration-300 ease-in-out ${data.hasOuterLayer ? 'p-1' : 'p-0'} ${data.onHoverContent && data.onHoverContent.length ? 'cursor-pointer' : ''} relative ${hovered === 4 && data.onHoverContent && data.onHoverContent.length ? 'z-20' : ''} rounded-[10px] h-[105px]`}
      style={{
        backgroundColor: data.hasOuterLayer ? data.outerLayerBg : null,
      }}
    >
      <div
        className={`pl-4 h-full flex  relative pt-2 pb-1 rounded-[10px]  overflow-hidden`}
        style={{ backgroundColor: data.bgColor }}
      >
        <div className={`h-full flex flex-col justify-between relative`}>
          <div className="flex flex-col gap-0">
            <h5
              className={
                data.bigText
                  ? "font-bold leading-none z-10 text-4xl font-['SF-Pro-Text-Regular, sans-serif']"
                  : "font-medium text-[28px] leading-none font-['SF-Pro-Text-Regular, sans-serif']"
              }
              style={{ color: data.countColor }}
            >
              {loading ? (
                <Spin
                  indicator={<LoadingOutlined spin />}
                  className="my-auto"
                />
              ) : (
                data.counts
              )}
            </h5>
            <span
              style={{ color: data.countsSubLabelColor }}
              className="leading-4 relative gap-2 top-0 tracking-wider text-[10px] font-['SF-Pro-Text-Regular, sans-serif']"
            >
              {data.countsSubLabel}
              {hovered ? null : data.onHoverContent &&
                data.onHoverContent.length ? (
                <img
                  src={data.hoverIcon}
                  alt="hover arrow icon"
                  className="absolute w-7 h-7 -top-1.5 left-1/2"
                />
              ) : null}
            </span>
          </div>
          <div
            className={`${data.hasOuterLayer ? 'flex flex-col leading-tight z-10' : 'pb-1 flex flex-col leading-tight'}`}
          >
            <h2
              className="text-[10px] uppercase font-bold tracking-wider font-['SF-Pro-Text-Regular, sans-serif']"
              style={{ color: data.labelColor }}
            >
              {data.label}
            </h2>
            {data.subLabel ? (
              <span
                style={{ color: data.labelColor }}
                className="text-[10px] uppercase font-bold tracking-wider font-['SF-Pro-Text-Regular, sans-serif']"
              >
                {data.subLabel}
              </span>
            ) : null}
          </div>
        </div>

        {hovered === 4 && data.onHoverContent && data.onHoverContent.length ? (
          <div className="top-0 flex-col w-24 gap-1 ml-5 animate-moveFromRight fle">
            {data.onHoverContent.map((item, index) => {
              return (
                <div
                  key={item.label}
                  className={`text-white flex relative pb-1 flex-col font-['SF-Pro-Text-Regular, sans-serif']`}
                >
                  <span className="text-sm font-medium">{item.counts}</span>
                  <span className="text-[8px] opacity-50 leading-tight">
                    {item.countsSubLabel}
                  </span>

                  {index === 0 ? (
                    <div className="absolute bottom-0 left-0 w-16 h-px bg-white opacity-50"></div>
                  ) : null}
                </div>
              );
            })}
          </div>
        ) : null}
        {/* icon */}
        <img
          src={data.icon}
          alt={data.label}
          className={`absolute ${data.iconClasses} -z-0`}
        />
      </div>
    </div>
  );
}
